import React from "react";
import * as Collapsible from "@radix-ui/react-collapsible";
import styles from "./collapse.module.scss";

export function Collapse(props: Props) {
  const {
    open,
    setOpen,
    contentNode,
    triggerNode,
    defaultOpen,
    rootClassname,
  } = props;

  return (
    <Collapsible.Root
      defaultOpen={defaultOpen}
      open={open}
      onOpenChange={setOpen}
      className={rootClassname}
    >
      <Collapsible.Trigger asChild>{triggerNode}</Collapsible.Trigger>
      <Collapsible.Content className={styles["contentContainer"]}>
        {contentNode}
      </Collapsible.Content>
    </Collapsible.Root>
  );
}

interface Props {
  open?: boolean;
  setOpen?: (e: boolean) => void;
  defaultOpen: boolean;
  contentNode: React.ReactNode;
  triggerNode: React.ReactNode;
  rootClassname?: string;
}
